import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import clsx from "clsx"
import { injectIntl } from "react-intl"

import AppBar from "@material-ui/core/AppBar"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogTitle from "@material-ui/core/DialogTitle"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"

import LoginDialog from "../LoginDialog/"
import defaultLogo from "../../pages/LoginPage/defaultLogo"
import messages from "./messages"

const drawerWidth = 240
const useStyles = makeStyles((theme) => ({
  appBar: {
    maxHeight: "12vh",
    position: "sticky",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  hide: {
    display: "none",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  logo: {
    marginTop: "6px",
  },
  logoImg: {
    height: "50px",
  },
}))

const MenuBar = ({
  closeLogin,
  closeLogout,
  handleDrawerOpen,
  intl: { formatMessage },
  isMobile,
  login,
  logout,
  open,
  openLogin,
  openLogout,
  passwordResetType,
  history,
  tenantSettings,
}) => {
  const classes = useStyles()

  const LoginComponents = () => (
    <>
      <LoginDialog
        open={openLogin}
        handleClose={closeLogin}
        handleLogin={login}
        passwordResetType={passwordResetType}
        history={history}
      />
      <Dialog open={openLogout}>
        <DialogTitle>{formatMessage(messages.logoutConfirm)}</DialogTitle>
        <DialogActions>
          <Button
            onClick={logout}
            color="primary"
            type="submit"
            variant="contained"
          >
            {formatMessage(messages.logout)}
          </Button>
          <Button onClick={closeLogout} color="secondary" variant="contained">
            {formatMessage(messages.cancel)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
  return isMobile ? (
    <LoginComponents />
  ) : (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          className={clsx(classes.menuButton, { [classes.hide]: open })}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap>
          <div className={classes.logo}>
            <img
              alt={tenantSettings.customerName}
              className={classes.logoImg}
              src={tenantSettings.serviceLogoUrl || defaultLogo}
            />
          </div>
        </Typography>
      </Toolbar>
      <LoginComponents />
    </AppBar>
  )
}

export default injectIntl(MenuBar)
